import { Helmet } from 'react-helmet';

export default function Services() {
    return (
        <>
            <Helmet>
                <title>Services | A. Page Code</title>
                <meta name="description" content="Basic example" />
            </Helmet>
            <h1>This is what we do...</h1>
        </>
    );
}